import React from "react";

import { graphql } from "gatsby";

import OptimizedImage from "cms/components/OptimizedImage";
import Text from "cms/components/Text";

import {
  ArticleLayoutVariant,
  Container,
  Content,
  Illustration,
  IllustrationContainer,
  Link,
} from "./BlogArticlesBlock.styles";

export interface BlogArticlesBlockProps
  extends Queries.SanityBlogArticlesBlock {}

const BlogArticlesBlock: React.FC<BlogArticlesBlockProps> = ({
  articleLayoutVariant,
  headline,
  blogArticlesItems,
}) => (
  <Container>
    <Content>
      {headline && (
        <Text variant="H3" as="h3">
          {headline}
        </Text>
      )}

      <IllustrationContainer
        $articleLayoutVariant={articleLayoutVariant as ArticleLayoutVariant}
      >
        {blogArticlesItems?.map((blogArticleItem) => (
          <Link
            href={blogArticleItem?.url || undefined}
            $articleLayoutVariant={articleLayoutVariant as ArticleLayoutVariant}
            key={blogArticleItem?.imageAlt}
          >
            <Illustration
              $articleLayoutVariant={
                articleLayoutVariant as ArticleLayoutVariant
              }
            >
              {blogArticleItem?.image && (
                <OptimizedImage
                  imageFit="fill"
                  image={blogArticleItem.image}
                  alt={blogArticleItem.imageAlt}
                />
              )}
            </Illustration>
          </Link>
        ))}
      </IllustrationContainer>
    </Content>
  </Container>
);

export const query = graphql`
  fragment BlogArticlesBlock on SanityBlogArticlesBlock {
    _key
    _type
    articleLayoutVariant
    headline
    blogArticlesItems {
      image { ...OptimizedImage }
      imageAlt
      url
    }
  }
`;

export default BlogArticlesBlock;
